<template>
  <div >

    <div class="text-h5 q-py-sm q-pl-sm">Liabilities</div>
    <template v-if="fieldValue !== undefined">
      <q-form
          @submit="onSubmit"
          ref="form"
      >
      <div class="full-width">

      <div class="row ">
        <div class="col-12 col-md-6 q-px-sm q-py-sm ">
          <FieldSelect
              v-model="fieldValue.type"
              :field="{layout_injected_label: 'Account Type', label: 'Account Type', required: true, requiredText: null,
                options: options
                }"
              :hide_bottom_space="true"
          ></FieldSelect>
        </div>
        <div class="col-12 col-md-6 q-px-sm q-py-sm ">
          <FieldText
              v-model="fieldValue.company"
              :field="{layout_injected_label: 'Company Name', label: 'Company Name', required: false, requiredText: null, options: {}}"
              :hide_bottom_space="true"
          ></FieldText>
        </div>

      </div>

        <div class="row ">
          <div class="col-12 col-md-6 q-px-sm q-py-sm ">
            <FieldText
                v-model="fieldValue.account"
                :field="{layout_injected_label: 'Account Number', label: 'Account Number', required: false, requiredText: null, options: {}}"
                :hide_bottom_space="true"
            ></FieldText>
          </div>
          <div class="col-12 col-md-6 q-px-sm q-py-sm ">
            <FieldMoney
                v-model="fieldValue.monthly_payment"
                :field="{layout_injected_label: 'Monthly Payment', label: 'Monthly Payment', required: false, requiredText: null, options: {}}"
            ></FieldMoney>
          </div>

        </div>
        <div class="row ">
          <div class="col-12 col-md-6 q-px-sm q-py-sm ">
            <FieldMoney
                v-model="fieldValue.unpaid_balance"
                :field="{layout_injected_label: 'Unpaid Balance', label: 'Unpaid Balance', required: false, requiredText: null, options: {}}"
                :hide_bottom_space="true"
            ></FieldMoney>
          </div>
          <div class="col-12 col-md-6 q-px-sm q-py-sm ">
            <q-checkbox v-model="fieldValue.to_be_paid_off" label="To be paid off at or before closing" />
          </div>

        </div>
      </div>
      </q-form>

    </template>


  </div>
</template>

<script>
import {mapFields} from "vuex-map-fields";
import FieldText from "@/components/fields/FieldText";
import FieldSelect from "@/components/fields/FieldSelect";

import FieldMoney from "@/components/fields/FieldMoney";

import banks from "@/components/modules/assets/institutions";

import {mapActions} from "vuex";
export default {
  components: {
    FieldText,
    FieldSelect,
    FieldMoney,

  },
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {
      banks: {},
      options: {
        'liability_revolving': 'Revolving (e.g., credit cards)',
        'liability_installment': 'Installment (e.g., car, student, personal loans)',
        'liability_open_30_day': 'Open 30-Day (balance paid monthly)',
        'liability_lease': 'Lease (not real estate)',
        'liability_Other': 'Other',
        'CollectionsJudgmentsAndLiens': 'Collections Judgments And Liens',
        'Taxes': 'Taxes',
        'HELOC': 'HELOC',
        'MortgageLoan': 'MortgageLoan'
      },
        real_estate_item: {
          address: "",
          unit: "",
          city: "",
          state: "",
          zip: "",
          country: "",
          property_type: "",
          status: "",
          intended_occupancy: "",
          market_value: "",
          monthly_gross_rent_income: "",
          current_mortgage_balance: "",
          monthly_rent_net_income: "",
          monthly_mortgage_payment: "",
          monthly_insurance: "",
          loans: [],
        },
        loan: {
          creditor_name: "",
          account_number: "",
          monthly_mortgage_payment: "",
          credit_limit: "",
          unpaid_balance: "",
          to_be_paid_off: false,
          type: ""
        },
        loan_types: {}
    };
  },
  emits: ['update:modelValue'],
  methods: {
    ...mapActions({
      nextScreen: 'values/list/nextScreen'
    }),
    AddItem() {

    },
    onSubmit() {

    },
    validate() {
      return this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    onAddressSelected(real_estate_item) {
      this.fieldValue.city = real_estate_item.city;
      this.fieldValue.state = real_estate_item.state;
      this.fieldValue.zip = real_estate_item.zipcode;
    },
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings',
      form: 'form'
    }),
    ...mapFields('values/list', {
      fieldValues: 'fieldValues'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please select';
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {
      console.log(banks);
      for(let i in banks) {
        this.banks[banks[i].name] = banks[i].name;
      }
  }
}
</script>
<style>
.field_no_bottom_line .q-field__control:before {
  border-bottom-color: transparent !IMPORTANT;
}
.field_no_bottom_line  .q-field__control:after {
  background: none !important;
}
.field_no_bottom_line .q-field__control {
  display: none;
}
.pac-container {
  z-index: 1000000;
}
</style>
